"use client";
import Select from "@/components/primitives/select";
import Tabs from "@/components/primitives/tabs";
import { ALL_YEARS_OPTIONS, SEASON_OPTIONS } from "@/data/sports/nfl/options";
import { generateYearOptions } from "@/utils";
import { useParamUpdater } from "@/utils/hooks/navigation";
import { Season, Sport, Year, getDefaultYear } from "common";
import { useRouter } from "next-nprogress-bar";
import React from "react";

export interface StandingsFilterParams {
  sport: Sport;
  year: string;
  season: Season;
  view: StandingsView;
}

const MLB_STANDINGS_VIEW_OPTIONS: Option[] = [
  {
    label: "Division",
    value: "division",
  },
  {
    label: "League",
    value: "league",
  },
  {
    label: "Overall",
    value: "overall",
  }
];

const STANDINGS_VIEW_OPTIONS: Option[] = [
  {
    label: "Division",
    value: "division",
  },
  {
    label: "Conference",
    value: "conference",
  },
  {
    label: "League",
    value: "league",
  }
];

export type StandingsView = "overall" | "league" | "conference" | "division";
export default function StandingsFilter({
  params,
}: {
  params: StandingsFilterParams;
}) {
  const { createParamString } = useParamUpdater();
  const router = useRouter();
  return (
    <>
      <Select
        label="Select Year"
        value={params.year}
        options={generateYearOptions(params.sport, getDefaultYear(params.sport), 4)}
        defaultValue={params.year}
        onValueChange={(v: Year) =>
          router.replace(createParamString(v, 2) || params.year, {
            scroll: false,
          })
        }
      />
      {/* <Select
        label="Select Season"
        value={params.season}
        options={SEASON_OPTIONS}
        defaultValue={params.season}
        onValueChange={(v: Season) =>
          router.replace(createParamString(v, 3) || params.season, {
            scroll: false,
          })
        }
      /> */}
      <Tabs
        variant="pill"
        label="Select View"
        value={params.view}
        defaultValue="league"
        block
        items={params.sport === "mlb" ? MLB_STANDINGS_VIEW_OPTIONS : STANDINGS_VIEW_OPTIONS}
        onValueChange={(v: string) => router.replace(createParamString(v, 3) || params.view)}
      />
    </>
  );
}
